// language=GraphQL
export const ALL_EXTENSION_MAP_ITEMS_QUERY = `query Query($withBaseAccommodation: Boolean = false, $withBaseAccommodationCapacitySettings: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withBaseAccommodationAddons: Boolean = false, $withBaseAccommodationAddonsCalculationSettings: Boolean = false, $withBaseAccommodationAddonsMandatorySettings: Boolean = false, $withExtensionAccommodation: Boolean = false) {
  extensionMapItems: ratioAccommodationExtensionMapItems {
    id
    baseAccommodation @include(if: $withBaseAccommodation) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
      capacitySettings @include(if: $withBaseAccommodationCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withBaseAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withBaseAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withBaseAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
    }
    extensionAccommodation @include(if: $withExtensionAccommodation) {
      id
      ratioPackageNo
      name
      label
      info
      extensionAccommodationServiceNo
    }
  }
}`

// language=GraphQL
export const SINGLE_EXTENSION_MAP_ITEM_QUERY = `query Query($id: ID!, $withBaseAccommodation: Boolean = false, $withBaseAccommodationCapacitySettings: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withBaseAccommodationAddons: Boolean = false, $withBaseAccommodationAddonsCalculationSettings: Boolean = false, $withBaseAccommodationAddonsMandatorySettings: Boolean = false, $withExtensionAccommodation: Boolean = false) {
  extensionMapItem: ratioAccommodationExtensionMapItem(id: $id) {
    id
    baseAccommodation @include(if: $withBaseAccommodation) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
      capacitySettings @include(if: $withBaseAccommodationCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withBaseAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withBaseAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withBaseAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
    }
    extensionAccommodation @include(if: $withExtensionAccommodation) {
      id
      ratioPackageNo
      name
      label
      info
      extensionAccommodationServiceNo
    }
  }
}`

// language=GraphQL
export const CREATE_EXTENSION_MAP_ITEM_MUTATION = `
  mutation Mutation($input: CreateRatioAccommodationExtensionMapItemInput, $withBaseAccommodation: Boolean = false, $withBaseAccommodationCapacitySettings: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withBaseAccommodationAddons: Boolean = false, $withBaseAccommodationAddonsCalculationSettings: Boolean = false, $withBaseAccommodationAddonsMandatorySettings: Boolean = false, $withExtensionAccommodation: Boolean = false) {
    extensionMapItem: createRatioAccommodationExtensionMapItem(input: $input) {
      id
      baseAccommodation @include(if: $withBaseAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withBaseAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withBaseAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withBaseAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withBaseAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
      }
      extensionAccommodation @include(if: $withExtensionAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        extensionAccommodationServiceNo
      }
    }
  }`

// language=GraphQL
export const UPDATE_EXTENSION_MAP_ITEM_MUTATION = `
  mutation Mutation($input: UpdateRatioAccommodationExtensionMapItemInput, $withBaseAccommodation: Boolean = false, $withBaseAccommodationCapacitySettings: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withBaseAccommodationAddons: Boolean = false, $withBaseAccommodationAddonsCalculationSettings: Boolean = false, $withBaseAccommodationAddonsMandatorySettings: Boolean = false, $withExtensionAccommodation: Boolean = false) {
    extensionMapItem: updateRatioAccommodationExtensionMapItem(input: $input) {
      id
      baseAccommodation @include(if: $withBaseAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withBaseAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withBaseAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withBaseAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withBaseAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
      }
      extensionAccommodation @include(if: $withExtensionAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        extensionAccommodationServiceNo
      }
    }
  }`

// language=GraphQL
export const DELETE_EXTENSION_MAP_ITEM_MUTATION = `
  mutation Mutation($input: DeleteRatioAccommodationExtensionMapItemInput) {
    deleteRatioAccommodationExtensionMapItem(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_EXTENSION_MAP_ITEM_MUTATION = `
  mutation Mutation($input: DeleteRatioAccommodationExtensionMapItemInput) {
    forceDeleteRatioAccommodationExtensionMapItem(input: $input) {
      success
    }
  }`
// language=GraphQL
export const EXTENSION_MAP_ITEMS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioTravelExtensions: Boolean = false) {
  groupedDependents: ratioAccommodationExtensionMapItemDependents(id: $id) {
    ratioTravelExtensions @include(if: $withRatioTravelExtensions) {
      id
      label
      info
    }
  }
}`
